import PaperTeal from "@assets/images/paper-teal.svg";
import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import TextAreaField from "@saleor/components/TextAreaField";
import { makeStyles } from "@saleor/macaw-ui";
import { FormikProps } from "formik";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface SaleTextModalProps {
  visible: boolean;
  onClose: () => void;
  initialValue: string;
  title: string;
  onSubmit?: (saleTextValue) => void;
  formik?: FormikProps<any>;
  saleTextIndex?: number;
  saleTextKey?: string;
  maxLength?: number;
}

export const useStyles = makeStyles(
  theme => ({
    dialogTitle: {
      textAlign: "left",
      padding: "5",
      display: "flex"
    },
    dialogTitleWrap: {
      height: "40px",
      display: " flex",
      alignItems: "center",
      lineHeight: "normal",
      marginBottom: "0px",
      marginTop: "0px",
      marginLeft: "15px"
    },
    root: {
      "& .MuiPaper-root": {
        maxWidth: 600,
        width: "100%",
        borderRadius: 12,
        padding: " 24px 32px"
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        paddingBottom: 24
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "1.4rem",
        lineHeight: "22px",
        color: theme.palette.grey[900]
      },
      "& .MuiRadio-root svg": {
        width: 18,
        height: 18
      }
    },
    buttonAction: {
      width: "50%",
      height: 48
    },
    buttonActions: {
      width: "89%",
      marginLeft: 20,
      padding: "8px 0px 2px 0px",
      gap: 8
    },
    nameHead: {
      marginTop: 0,
      marginLeft: "12px",
      display: "flex !important",
      h2: {
        display: "flex !important"
      }
    }
  }),
  { name: "ModalAddress" }
);

const SaleTextModal: React.FC<SaleTextModalProps> = props => {
  const {
    visible,
    onClose,
    initialValue,
    title,
    onSubmit,
    formik,
    saleTextIndex,
    saleTextKey,
    maxLength
  } = props;
  const classes = useStyles();
  const intl = useIntl();
  const [saleTextValue, setSaleTextValue] = useState<string>(initialValue);

  const dataRenderModal = {
    iconHead: PaperTeal,
    nameHead: intl.formatMessage({
      defaultMessage: title
    })
  };

  const handleChange = event => {
    setSaleTextValue(event?.target?.value);
  };

  const handleSubmit = () => {
    const mapSaleTextKey = `lines[${saleTextIndex}].${saleTextKey}`;
    formik.setFieldValue(mapSaleTextKey, saleTextValue);
    onSubmit(saleTextValue);
    onClose();
  };

  return (
    <Dialog
      open={visible}
      onClose={onClose}
      className={classes.root}
      data-testid="saleTextModal"
    >
      <DialogTitle className={classes.dialogTitle}>
        <h2 className={classes.dialogTitleWrap}>
          <img src={dataRenderModal?.iconHead} alt="" />
          <MyTypography variant={"h6"} className={classes.nameHead}>
            {dataRenderModal?.nameHead}
          </MyTypography>
        </h2>
      </DialogTitle>
      <TextAreaField
        name="พิมพ์ที่นี่..."
        onChange={handleChange}
        value={saleTextValue}
        title={null}
        maxLength={maxLength}
        lineLimit={132}
        rowsMax={10}
        className={classes.buttonActions}
        id={`lines[${saleTextIndex}].${saleTextKey}Field`}
        data-testid={`lines[${saleTextIndex}].${saleTextKey}Field`}
      />
      <DialogActions>
        <Button
          id="cancelButton"
          data-testid="cancelButton"
          variant={"outlined"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={onClose}
        >
          <FormattedMessage defaultMessage={"ยกเลิก"} />
        </Button>
        <Button
          id="submitButton"
          data-testid="submitButton"
          variant={"contained"}
          color={"secondary"}
          className={classes.buttonAction}
          onClick={handleSubmit}
        >
          <FormattedMessage defaultMessage={"ตกลง"} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaleTextModal;
